"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFilledEditableTextLayerUserData = exports.filledEditableTextLayerUserDataRuleSet = exports.isEditableTextLayerUserData = exports.editableTextLayerUserDataRuleSet = void 0;
const typeguards_1 = require("au-types/lib/typeguards");
const typeguard_1 = require("../../types/typeguard");
exports.editableTextLayerUserDataRuleSet = {
  content: (0, typeguard_1.optional)(typeguards_1.isString),
  rawText: (0, typeguard_1.optional)(typeguards_1.isString),
  fontFace: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  fontSize: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  textAlign: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  assetId: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString)
};
const isEditableTextLayerUserData = e => (0, typeguard_1.isType)(e, exports.editableTextLayerUserDataRuleSet);
exports.isEditableTextLayerUserData = isEditableTextLayerUserData;
exports.filledEditableTextLayerUserDataRuleSet = {
  content: (0, typeguard_1.optional)(typeguards_1.isString),
  rawText: (0, typeguard_1.optional)(typeguards_1.isString),
  fontFace: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  fontSize: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  textAlign: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  assetId: typeguard_1.isNonEmptyString
};
const isFilledEditableTextLayerUserData = e => (0, typeguard_1.isType)(e, exports.filledEditableTextLayerUserDataRuleSet);
exports.isFilledEditableTextLayerUserData = isFilledEditableTextLayerUserData;